import 'primeicons/primeicons.css'
import { PerformanceStandardsComponent } from '../components/PerformanceStandards'
import ComponentHeader from './ComponentHeader'
import { useAppContext } from '../Context';

function PerformanceStandards() {
  const items = [
    //{ label: 'Files', url: '/files' },
    // { label: 'Submissions', url: '/submissions' },
    { label: 'PBC Standards & Measures', path: '/standards' }]

  const { providerType, reviewYear } = useAppContext();
  
  return (
    <div style={{ marginTop: '42px', marginBottom: '50px', marginLeft: '5px' }}>
      <ComponentHeader title='PBC Standards & Measures' breadcrumbs={items} />
      <PerformanceStandardsComponent providerType={providerType} reviewYear={reviewYear} />
    </div>
  )
}

export default PerformanceStandards